<script lang="ts">
	export let title: string;
</script>

<div>
	<div class="text-lg mb-2">{title}</div>
	<slot />
</div>
